

<style>
.divider {
  height: 1px; /* Adjust height as needed */
  background-color: #ccc; /* Change color as needed */
  margin: 8px 0; /* Adjust spacing as needed */
}
.completed {
  background-color: #e8f5e9;
}
.text-wrap2{
  flex-wrap: wrap;
    overflow: initial !important;
    display: flex !important;
}
.p30{
  padding: 30px !important;
}
</style>

<template>
    <v-app>
    <Appbar :defaultTitle="true"></Appbar>
    <v-main>
      <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card>
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(step,index) in steps"
                :key="step.id"
                @click="toggleStep(step,index)"
                :class="'p30 '+ { 'completed': step.completed }"
              >
                <template v-slot:prepend>
                  <v-btn
                    icon
                    :color="step.completed ? 'success' : 'grey'"
                    class="mr-4"
                   
                  >
                    <v-icon> 
                      {{ step.completed ? "mdi-check" : 'mdi-circle-outline' }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list-item-title>{{ step.title }}</v-list-item-title>
                <v-list-item-subtitle class="text-wrap2">{{ step.description }}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
    </v-main>
    <Toast ref="toast" msgxx="msgxx"/>
  </v-app>

</template>
  
<script src="./mission-operation.ts"></script>
